export const GET_ENCRYPTED_PSEUDONYMS_FAILURE = 'GET_ENCRYPTED_PSEUDONYMS_FAILURE';

export const getEncryptedPseudonymsFailure = error => ({
    type: GET_ENCRYPTED_PSEUDONYMS_FAILURE,
    payload: error,
    error: true,
});
